import BarLoader from 'react-spinners/BarLoader'

let Loader = () => {
    return <div className="loader">
        <BarLoader color={"#f05454"} height={5}></BarLoader>
    </div>
}

export default Loader